import { createRouter, createWebHistory } from 'vue-router'
import _ from 'lodash'

import Index from '@/pages/Index.vue'
import Welcome from '@/pages/Welcome.vue'
import NotFound from '@/pages/NotFound.vue'
import Headset from '@/pages/Headset.vue'
import Demo from '@/pages/Demo.vue'
// import Impersonate from '@/pages/Impersonate.vue'

import { useAuthentication } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/welcome',
      name: 'welcome',
      meta: { requiresAuthentication: false },
      component: Welcome
    },
    {
      path: '/demo/:token',
      name: 'demo',
      meta: { requiresAuthentication: false },
      component: Demo
    },
    /*{
      path: '/impersonate',
      name: 'impersonate',
      meta: { requiresAuthentication: false },
      component: Impersonate
    },*/
    {
      path: '/',
      name: 'index',
      meta: { requiresAuthentication: true },
      component: Index
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: NotFound
    }
  ]
})


router.beforeResolve(async (to, from) => {
  if (to.name === 'demo' || to.path.startsWith('/demo/')) return true
  let authenticationStore = null
  if (
    (!_.has(from, 'meta') || _.isEmpty(from.meta)) &&
    to?.redirectedFrom?.path == null &&
    !to.path.startsWith('/invite/') &&
    !to.path.startsWith('/demo/') &&
    !to.path.startsWith('/login_user/') &&
    !/^\/register_user\/[^/]+\/invite\/[^/]+$/.test(!to.path)
  ) {
    if (authenticationStore == null) authenticationStore = useAuthentication()
    await authenticationStore.fetchSession(true)
  }
  if (_.has(to, 'meta') && _.has(to.meta, 'requiresAuthentication')) {
    if (authenticationStore == null) authenticationStore = useAuthentication()
    if (to.meta.requiresAuthentication && !authenticationStore.isAuthenticated)
      return {
        path: '/welcome'
      }
    else if (to.path == '/welcome' && authenticationStore.isAuthenticated)
      return {
        path: '/'
      }
    return true
  } else if (to.path.startsWith('/invite/')) {
    const inviteCode = to.path.substring('/invite/'.length)
    if (inviteCode.length > 0) {
      if (authenticationStore == null) authenticationStore = useAuthentication()
      await authenticationStore.invite(inviteCode)
      return {
        path: '/welcome'
      }
    }
    return true
  } else if (to.path.startsWith('/register_user/')) {
    const [, provider, inviteCode] =
      to.path.match(/\/register_user\/([^/]+)\/invite\/(.+)/) || []
    if (provider != null && inviteCode != null) {
      if (authenticationStore == null) authenticationStore = useAuthentication()
      await authenticationStore.invite(inviteCode, provider)
      return {
        path: '/welcome'
      }
    }
    return true
  } else if (to.path.startsWith('/login_user/')) {
    const provider = to.path.substring('/login_user/'.length)
    if (authenticationStore == null) authenticationStore = useAuthentication()
    await authenticationStore.login(provider)
    return {
      path: '/'
    }
  } else if (to.path.startsWith('/password/')) {
    const resetCode = to.path.substring('/password/'.length)
    if (resetCode.length > 0) {
      if (authenticationStore == null) authenticationStore = useAuthentication()
      await authenticationStore.getForgotPassword(resetCode)
      return {
        path: '/'
      }
    }
    return true
  }
})

export default router
